export function openEntityChartOfAccounts({
    workspaceId,
    entityId,
}: {
    workspaceId: string;
    entityId: number;
}) {
    const url = new URL("/open", window.location.origin);
    url.searchParams.set("workspaceId", workspaceId);
    url.searchParams.set("entityId", String(entityId));
    url.searchParams.set("target", "chartOfAccounts");
    window.open(url.toString(), "_blank", "noopener,noreferrer");
}
